import { render } from "./TestSolver.vue?vue&type=template&id=33e5c690&scoped=true"
import script from "./TestSolver.vue?vue&type=script&lang=js"
export * from "./TestSolver.vue?vue&type=script&lang=js"

import "./TestSolver.vue?vue&type=style&index=0&id=33e5c690&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e5c690"]])

export default __exports__